import styled from 'styled-components';

export const Container = styled.div`
    min-width: 320px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: var(--background);
    color: var(--text-primary);
`;

export const Content = styled.div`
    flex: 1;
`;
